import React from 'react';
import Toolbox from './Toolbox';
import Icon from './Icon';
import styles from '../../../../stylesheet/css/header-builder/element-holder.css';

export const ElementHolder = React.createClass({
    getInitialState(){
        return {
            "headerNavActive": "",
            "elementNavActive": ""
        };
    },

    toggleHeaderNav() {
        var css = (this.state.headerNavActive === styles.shortcutElementActive) ? "" : styles.shortcutElementActive;
        this.setState({
          ...this.state,
          headerNavActive: css
        });
        if (this.state.elementNavActive === styles.shortcutElementActive) {
            this.setState({
              ...this.state,
              elementNavActive: ""
            });
        }
    },

    toggleElementNav() {
        var css = (this.state.elementNavActive === styles.shortcutElementActive) ? "" : styles.shortcutElementActive;
        this.setState({
          ...this.state,
          elementNavActive: css
        });
        if (this.state.headerNavActive === styles.shortcutElementActive) {
            this.setState({
              ...this.state,
              headerNavActive: ""
            });
        }
    },

    render(){
        return (
            <div>
                <ul className={styles.shortcutWrapper}>
                    <li className={this.state.headerNavActive} onClick={this.toggleHeaderNav}>
                        <a className={styles.headerShortcut}>
                            <Icon icon="header-shortcut" w="24px" h="19px" vb="0 0 24 19"/>
                         </a>
                        {this.state.headerNavActive != '' &&
                            <div className={styles.headerShortcutPanel}>
                            </div>
                        }
                    </li>
                    <li className={this.state.elementNavActive + ' shortcut-element-nav'} onClick={this.toggleElementNav}>
                        <a className={styles.elementShortcut}>
                            <Icon icon="element-shortcut" w="27px" h="27px" vb="0 0 27 27"/>
                        </a>
                        {this.state.elementNavActive != '' &&
                            <div className={styles.elementShortcutPanel}>
                                <Toolbox />
                            </div>
                        }
                    </li>

                </ul>
            </div>
        );
    }
});

export default ElementHolder;



// WEBPACK FOOTER //
// ./app/header-builder/components/ElementHolder.js